import React, { useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { makeStyles } from "@mui/styles";
import { useAuth } from "../../context/AuthContext";
import DashboardMenu from "./DashboardMenu";

const useStyles = makeStyles({
  root: { width: 1, display: "flex", paddingBottom: "100px" },
  body: {
    width: "100%",
    borderRadius: "5px",
    border: "1px solid lightgray",
    marginBottom: "30px",
  },
  inputEach: {
    display: "flex",
    alignItems: "center",
    paddingLeft: "10px",
    paddingRight: "10px",
    marginBottom: "20px",
    marginTop: "20px",
  },
  inputs: { width: "70%" },
  label: { width: "160px" },
});

const AdminDashboard = () => {
  const { currentUser } = useAuth();
  const classes = useStyles();
  const [orders, setOrders] = useState([]);
  const [err, setErr] = useState(null);

  //   useEffect(() => {
  //     setOrders([]);
  //     const getOrders = async () => {
  //       let ref = await collection(db, "orders");
  //       const q = query(ref, where("user_uid", "==", currentUser.uid));
  //       const querySnapshot = await getDocs(q);
  //       querySnapshot.forEach((doc2) => {
  //         console.log(doc2.id, " => ", doc2.data());

  //         const docRef = doc(db, "users", doc2.data().user_uid);
  //         getDoc(docRef).then(async (res) => {
  //           console.log(res.data());
  //           setOrders((old) =>
  //             old.concat({
  //               ...doc2.data(),
  //               firstname: res.data().firstname,
  //               lastname: res.data().lastname,
  //               phone: res.data().phone,
  //             })
  //           );
  //         });
  //       });
  //     };
  //     getOrders();
  //   }, []);

  console.log(orders);

  //   const getUser = async (userId) => {
  //     const docRef = doc(db, "users", userId);
  //     await getDoc(docRef).then((res) => {
  //       return res.data();
  //     });
  //   };

  return (
    <Grid className={classes.root} container sx={{ px: 10 }}>
      <Grid
        item
        sm={12}
        md={3}
        sx={{
          // border: "1px solid black",
          px: { md: 3 },
          py: { md: 5, sm: 4 },
        }}
      >
        <DashboardMenu page="reviews" />
      </Grid>
      <Grid
        sm={12}
        md={8}
        item
        sx={{
          // border: "1px solid black",
          px: { md: 3 },
          py: { md: 5, sm: 2 },
        }}
      >
        <Box className={classes.body}>
          <Box
            sx={{
              width: "100%",
              py: 2,
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                boxSizing: "border-box",
                px: 4,
              }}
            >
              <Box sx={{ width: 1 }}>
                <Box
                  sx={{
                    pt: 1,
                    fontSize: "23px",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <Box sx={{ pb: 4 }}>All Reviews</Box>
                  <Box sx={{ color: "blue", pb: 2 }}>{err}</Box>
                </Box>
              </Box>

              <Box sx={{ width: 1 }}></Box>
            </Box>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default AdminDashboard;
